'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sideNavigation = require('./../../side-navigation');

var _sideNavigation2 = _interopRequireDefault(_sideNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SideNavContent = function SideNavContent(props) {
  return _react2.default.createElement(_sideNavigation2.default, props);
};
exports.default = SideNavContent;


SideNavContent.propTypes = _sideNavigation2.default.propTypes;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/side-nav-content/jsx/SideNavContent.js
// module id = 1140
// module chunks = 4